'use client';

import {
  Carousel,
  CAROUSEL_ARROW_DESIGNS,
  CAROUSEL_ARROW_POSITION,
  CAROUSEL_ARROW_REVEAL,
  CAROUSEL_ARROW_SIZES,
} from '@highereducation/hen-ui';

export type CarouselShortcodeProps = {
  'show-controls'?: boolean;
  'show-dots'?: boolean;
  loop?: boolean | string;
  'arrow-reveal'?: string;
  'arrow-position'?: string;
  'arrow-design'?: string;
  'arrow-size'?: string;
  children?: React.ReactNode;
};

function toAllowed<T extends string>(
  allowed: readonly T[],
  value: string | undefined,
): T | undefined {
  return allowed.find((option) => option === value);
}

function toLoop(value: boolean | string | undefined): boolean | undefined {
  if (value === true || value === 'true') {
    return true;
  }
  if (value === false || value === 'false') {
    return false;
  }
  return undefined;
}

export function CarouselShortcodeClient({
  'show-controls': showControls,
  'show-dots': showDots,
  loop,
  'arrow-reveal': arrowReveal,
  'arrow-position': arrowPosition,
  'arrow-design': arrowDesign,
  'arrow-size': arrowSize,
  children,
}: CarouselShortcodeProps) {
  return (
    <Carousel
      showControls={showControls}
      showDots={showDots}
      loop={toLoop(loop)}
      arrowReveal={toAllowed(CAROUSEL_ARROW_REVEAL, arrowReveal)}
      arrowPosition={toAllowed(CAROUSEL_ARROW_POSITION, arrowPosition)}
      arrowDesign={toAllowed(CAROUSEL_ARROW_DESIGNS, arrowDesign)}
      arrowSize={toAllowed(CAROUSEL_ARROW_SIZES, arrowSize)}
    >
      {children}
    </Carousel>
  );
}
